var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/users_content.9125bff4.png","uri@2x": __webpack_public_path__ + "static/media/users_content.b7344e54.png","uri@3x": __webpack_public_path__ + "static/media/users_content.f7967a45.png",
    width: 24,
    height: 20
});